<template>
  <div class="ios-sign-rule">
    <h1>{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}普通会员连续包月服务协议
    </h1>
    <p>1、连续包月会员服务的开通，视为您授权才博有权在您的服务即将到期时，从包括但不限于您的自有充值账户、与会员账号绑定的第三方支付账户、银行卡、通信账户、iTunes账户（以下统称“账户”）余额中代扣下一个计费周期包月费。<br>
      2、购买确认后，将支付到iTunes帐户。<br>
      3、如您选择取消连续包月服务，需要在当月结束的至少24小时前取消订阅，否则系统仍将会自动续订。<br>
      4、在本期结束前24小时内将收取续期费用，并确定续期费用。<br>
      5、订阅可由您管理，购买后可转到您的帐户设置，自动更新可能关闭。<br>
      6、非因用户违反国家法律法规的规定或本服务条款规定，您可以选择退订连续包月服务，但是开通时当月的服务费用无法退还。<br>
      7、若选择连续包月服务，您可通过下述方式中止或终止本服务：苹果应用内支付（IAP支付，in-app purchase）自动续费用户退订方法如下：打开苹果手机“设置” --> 进入“iTunes Store 与 App Store”-->点击 “Apple ID”，选择"查看Apple ID"，进入"账户设置"页面，点击“订阅”，选择相应的订阅项取消即可。<br>
      8、才博有权根据用户的需求、产品及服务内容的变化等，对现有会员连续包月的期限、价格及相关内容进行调整，以不断完善、优化服务。<br>
      9、如用户对本服务条款内容有任何疑问，可发邮件至（wpsedukf@kingsoft.com）。
    </p>
  </div>
</template>

<script>

export default {
  computed: {
  },
  methods: {
  },
  beforeCreate () {
  },
  created () {
    this.init()
  },
  beforeDestroy () {
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.ios-sign-rule {
  line-height: 2;
  font-size: rem(22);
  padding: rem(10);
  h1 {
    text-align: center;
    font-size: rem(26);
  }
  h2, p {
    text-align: left;
  }
}
</style>
